import { NgModule } from '@angular/core';
import { BookingTravellerComponent } from "./booking-traveller.component";
import { CommonModule } from "@angular/common";
import { BookingTravellerAbstractModule } from "./components/booking-traveller-abstract/booking-traveller-abstract.module";
import { BookingTravellerDetailModule } from "./components/booking-traveller-detail/booking-traveller-detail.module";
import { BookingTravellerTicketModule } from "./components/booking-traveller-ticket/booking-traveller-ticket.module";
import { BookingContactsContactModule } from 'libraries/component/booking-contacts-contact/booking-contacts-contact.module';

@NgModule({
    imports: [
        CommonModule,
        BookingTravellerAbstractModule,
        BookingTravellerDetailModule,
        BookingContactsContactModule,
        BookingTravellerTicketModule,
    ],
    exports: [
        BookingTravellerComponent
    ],
    declarations: [
        BookingTravellerComponent
    ],
    providers: [],
})
export class BookingTravellerModule {
}